document.addEventListener('DOMContentLoaded', () => {

    const filter = document.getElementById('wcl-filter');
    if (!filter) return;

    const isToolsPage = filter.getAttribute('data-is-tools-page') === 'true';
    const isPlatformPage = filter.getAttribute('data-is-platform-page') === 'true';

    const toggle = document.getElementById('wcl-filter-toggle');
    const close = document.getElementById('wcl-filter-close');
    const overlay = document.getElementById('wcl-filter-overlay');

    const open = () => {
        filter.classList.add('is-open');
        overlay?.classList.add('is-visible');
        document.body.classList.add('overflow-hidden');
        toggle?.setAttribute('aria-expanded', 'true');
    };

    const closeFn = () => {
        filter.classList.remove('is-open');
        overlay?.classList.remove('is-visible');
        document.body.classList.remove('overflow-hidden');
        toggle?.setAttribute('aria-expanded', 'false');
    };

    toggle?.addEventListener('click', open);
    close?.addEventListener('click', closeFn);
    overlay?.addEventListener('click', closeFn);

    // ===== FORM HANDLING =====

    const form = filter.querySelector('form');
    if (!form) return;

    form.addEventListener('change', (e) => {

        if (e.target.matches('input[type="checkbox"]')) {

            if (isToolsPage || isPlatformPage) {
                form.submit();
                return;
            }

            const url = e.target.getAttribute('data-url');
            if (url) {
                window.location.href = url;
            }
            return;

        }

        if (e.target.matches('input[name="search"]')) {
            form.submit();
        }

    });

});